
const STORAGE_KEY = 'participante_idioma';
let _cache = null;

export const getStored = () => {
    if (_cache) return _cache;
    const stored = sessionStorage.getItem(STORAGE_KEY);
    _cache = stored ? JSON.parse(stored) : null;
    return _cache;
};

const getFallback = (idioma)=> {
    const portugues = {
                error: "Erro: ",
                errorRefreshPage: ' tente atualizar a página',
                loading:"Carregando...",
                errorBoundaryTitle: 'Algo deu errado ao carregar esta página',
                errorBoundaryMessage: 'Tente recarregar. Se o problema continuar, entre em contato com a organização do evento.',
                errorBoundaryReload: 'Recarregar a página'
            }
    const ingles = {
                error: "Error: ",
                errorRefreshPage:' try refreshing the page',
                loading: "Loading...",
                errorBoundaryTitle: 'Something went wrong while loading this page',
                errorBoundaryMessage: 'Please reload. If the problem persists, contact the event organization.',
                errorBoundaryReload: 'Reload the page'
            }
    return {
            portugues,
            ingles
        }[idioma] ?? ingles
};

export const saveIdioma = (idioma) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(idioma));
    _cache = idioma;
};

export const getIdiomaCodigo = () => {
    return getStored()?.codigo ?? 'portugues';
};

// Locale (ex.: 'pt-BR', 'en-US') do idioma atual — para formatar data/número no
// mesmo idioma exibido. Usa o `codigo_locale` do idioma (banco), cai num mapa
// por codigo e default 'pt-BR'.
export const getIdiomaLocale = () => {
    const stored = getStored();
    if (stored?.codigo_locale) return stored.codigo_locale;
    const codigo = stored?.codigo ?? 'portugues';
    return { portugues: 'pt-BR', ingles: 'en-US' }[codigo] ?? 'pt-BR';
};

// Prioridade: traducao_ui do banco (via sessionStorage) → fallback estático por idioma
export const getText = (key, idioma = getIdiomaCodigo()) => {
    const dinamico = getStored()?.traducao_ui ?? getFallback(idioma)
    if (dinamico?.[key] !== undefined) return dinamico[key];
};
